/* ═══════════════════════════════════════
   JIRO ARCHIVE — SEARCH ENGINE
   Uses Shopify's Predictive Search API
   ═══════════════════════════════════════ */

(function() {

  var overlay     = document.getElementById('searchOverlay');
  var backdrop    = document.getElementById('searchBackdrop');
  var input       = document.getElementById('searchInput');
  var resultsGrid = document.getElementById('searchResultsGrid');
  var countEl     = document.getElementById('searchResultsCount');
  var triggers    = document.querySelectorAll('.search-trigger');
  var closeBtn    = document.getElementById('searchClose');
  var filterPills = document.querySelectorAll('.search-filter-pill');

  if (!overlay || !input) return;

  var currentFilter = 'all';
  var debounceTimer = null;
  var currentQuery  = '';

  /* ── Open / Close ── */
  function openSearch() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { input.focus(); }, 280);
    showInitialState();
  }

  function closeSearch() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    input.value = '';
    currentQuery = '';
    showInitialState();
  }

  triggers.forEach(function(t) {
    t.addEventListener('click', openSearch);
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      overlay.classList.contains('open') ? closeSearch() : openSearch();
    }
  });

  /* ── Filter pills ── */
  filterPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      filterPills.forEach(function(p) { p.classList.remove('active', 'active-accent'); });
      pill.classList.add('active');
      currentFilter = pill.dataset.filter || 'all';
      if (currentQuery.length >= 2) fetchResults(currentQuery);
    });
  });

  /* ── Input handler ── */
  input.addEventListener('input', function() {
    var q = input.value.trim();
    currentQuery = q;
    clearTimeout(debounceTimer);
    if (q.length < 2) { showInitialState(); return; }
    showLoading();
    debounceTimer = setTimeout(function() { fetchResults(q); }, 280);
  });

  /* ── Shopify Predictive Search API ── */
  function fetchResults(q) {
    var types = 'product';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=' + types
            + '&resources[limit]=12'
            + '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        // Filter by collection/type tag if filter is set
        if (currentFilter !== 'all') {
          products = products.filter(function(p) {
            if (!p.tags) return false;
            return p.tags.toLowerCase().indexOf(currentFilter) !== -1
              || (p.product_type && p.product_type.toLowerCase().indexOf(currentFilter) !== -1);
          });
        }
        renderResults(products, q);
      })
      .catch(function() {
        renderError();
      });
  }

  /* ── Render results ── */
  function renderResults(products, q) {
    if (!resultsGrid) return;

    if (countEl) {
      countEl.textContent = products.length + ' result' + (products.length !== 1 ? 's' : '') + ' for \u201c' + q + '\u201d';
    }

    if (products.length === 0) {
      resultsGrid.innerHTML = '<div class="search-no-results">'
        + '<p>\u201cNothing found for \u2018' + escHtml(q) + '\u2019\u201d</p>'
        + '<p>Try a different search, or <a href="/pages/sourcing" style="color:var(--accent);text-decoration:none;">request a specific piece</a>.</p>'
        + '</div>';
      return;
    }

    resultsGrid.innerHTML = products.map(function(p) {
      var available = p.available !== false;
      var imgHtml = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url + '" alt="' + escAttr(p.title) + '" loading="lazy"/>'
        : '<div class="search-result-img-placeholder"><span>' + escHtml(p.title) + '</span></div>';

      var soldOverlay = !available
        ? '<div class="search-result-sold-overlay"><span class="search-result-sold-label">Sold</span></div>'
        : '';

      var priceHtml = p.price_min
        ? '<p class="search-result-price' + (!available ? ' sold' : '') + '">' + formatMoney(p.price_min) + '</p>'
        : '';

      var highlightedTitle = highlightQuery(escHtml(p.title), q);

      return '<a href="' + escAttr(p.url) + '" class="search-result-card" onclick="closeSearchGlobal()">'
        + '<div class="search-result-img">' + imgHtml + soldOverlay + '</div>'
        + '<p class="search-result-house">' + escHtml(p.vendor || '') + '</p>'
        + '<p class="search-result-name">' + highlightedTitle + '</p>'
        + priceHtml
        + '</a>';
    }).join('');
  }

  /* ── States ── */
  function showInitialState() {
    if (countEl) countEl.textContent = '';
    if (!resultsGrid) return;
    resultsGrid.innerHTML = '<div class="search-state">'
      + '<div class="search-state-icon">◈</div>'
      + '<p class="search-state-title">Search the archive.</p>'
      + '<p class="search-state-sub">Designers, eras, silhouettes\u2026</p>'
      + '</div>';
  }

  function showLoading() {
    if (countEl) countEl.textContent = 'Searching\u2026';
    if (!resultsGrid) return;
    var shimmerCard = '<div class="search-shimmer-card">'
      + '<div class="search-shimmer search-shimmer-img"></div>'
      + '<div class="search-shimmer search-shimmer-line"></div>'
      + '<div class="search-shimmer search-shimmer-line-sm"></div>'
      + '</div>';
    resultsGrid.innerHTML = shimmerCard + shimmerCard + shimmerCard + shimmerCard;
  }

  function renderError() {
    if (countEl) countEl.textContent = '';
    if (!resultsGrid) return;
    resultsGrid.innerHTML = '<div class="search-state">'
      + '<p class="search-state-title">Something went wrong.</p>'
      + '<p class="search-state-sub">Try again or <a href="/search" style="color:var(--accent);">browse all</a>.</p>'
      + '</div>';
  }

  /* ── Suggestion pills click ── */
  document.querySelectorAll('.search-suggestion-item').forEach(function(item) {
    item.addEventListener('click', function(e) {
      var q = item.dataset.query;
      if (q) {
        e.preventDefault();
        input.value = q;
        currentQuery = q;
        showLoading();
        fetchResults(q);
      }
    });
  });

  /* ── Helpers ── */
  function highlightQuery(str, q) {
    if (!q) return str;
    var escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return str.replace(new RegExp('(' + escaped + ')', 'gi'),
      '<em class="search-highlight">$1</em>');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;');
  }

  function escAttr(s) { return escHtml(s); }

  /* Expose close for inline onclick */
  window.closeSearchGlobal = closeSearch;

})();
